define( function() {
	return [ "Top", "Right", "Bottom", "Left" ];
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/css/var/cssExpand.js
 ** module id = 850
 ** module chunks = 2
 **/